import * as angular from "angular";
import {IController} from "angular";

export class VolumeCapacityComponent implements IController {
  volumeLoad: any;
  maxLoad: any;

  constructor() {
  }

}

angular
  .module('bringoz.admin.commons')
  .component('volumeCapacity', {
    bindings: {
      volumeLoad: '<',
      maxLoad: '<'
    },
    templateUrl: 'app/modules/commons/components/volume-capacity/volume-capacity.html',
    controller: VolumeCapacityComponent
  });
